"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TagManagementDataHandler = require("./TagManagementDataHandler");
Object.keys(_TagManagementDataHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TagManagementDataHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TagManagementDataHandler[key];
    }
  });
});
var _TagManagementSystemsConfig = require("./TagManagementSystemsConfig");
Object.keys(_TagManagementSystemsConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TagManagementSystemsConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TagManagementSystemsConfig[key];
    }
  });
});
var _setupTagManagementSystems = require("./setupTagManagementSystems");
Object.keys(_setupTagManagementSystems).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _setupTagManagementSystems[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _setupTagManagementSystems[key];
    }
  });
});